'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStripeValidationError = exports.isStripeError = exports.getTokenPromise = exports.withStripeElements = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tokenPromises = {};

var withStripeElements = exports.withStripeElements = function withStripeElements(StripeForm) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    (0, _inherits3.default)(StripeElementsForm, _Component);

    function StripeElementsForm(props) {
      (0, _classCallCheck3.default)(this, StripeElementsForm);

      var _this = (0, _possibleConstructorReturn3.default)(this, (StripeElementsForm.__proto__ || (0, _getPrototypeOf2.default)(StripeElementsForm)).call(this, props));

      _this.state = {};


      _this.onSetStripePromise = _this.onSetStripePromise.bind(_this);
      return _this;
    }

    (0, _createClass3.default)(StripeElementsForm, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (window.Stripe) {
          this.stripeAvailable();
        } else {
          this.stripeAvailabilityListener = this.stripeAvailable.bind(this);
          document.body.addEventListener('stripeReady', this.stripeAvailabilityListener);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.stripeAvailabilityListener) {
          document.body.removeEventListener('stripeReady', this.stripeAvailabilityListener);
          delete this.stripeAvailabilityListener;
        }

        var tokenPromiseKey = this.state.tokenPromiseKey;

        if (tokenPromiseKey) {
          delete tokenPromises[tokenPromiseKey];
        }
      }
    }, {
      key: 'onSetStripePromise',
      value: function onSetStripePromise(stripePromise) {
        var onTokenPromiseKey = this.props.onTokenPromiseKey;


        var tokenPromiseKey = String(Math.random()).substr(2, 10);
        tokenPromises[tokenPromiseKey] = stripePromise;
        onTokenPromiseKey(tokenPromiseKey);

        this.setState({
          tokenPromiseKey: tokenPromiseKey
        });
      }
    }, {
      key: 'getCurrentLanguage',
      value: function getCurrentLanguage() {
        var currentLocale = this.props.intl.locale;


        return currentLocale.split('-')[0];
      }
    }, {
      key: 'stripeAvailable',
      value: function stripeAvailable() {
        if (this.stripeAvailabilityListener) {
          document.body.removeEventListener('stripeReady', this.stripeAvailabilityListener);
          delete this.stripeAvailabilityListener;
        }

        var stripe = window.Stripe;
        var elements = stripe.elements({ locale: this.getCurrentLanguage() });

        var onLoadingStateChanged = this.props.onLoadingStateChanged;


        onLoadingStateChanged(false);

        this.setState({
          stripe: stripe,
          elements: elements
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            stripe = _state.stripe,
            elements = _state.elements,
            tokenPromiseKey = _state.tokenPromiseKey;


        return _react2.default.createElement(StripeForm, (0, _extends3.default)({
          stripe: stripe,
          elements: elements,
          tokenPromise: tokenPromiseKey,
          setStripePromise: this.onSetStripePromise
        }, this.props));
      }
    }]);
    return StripeElementsForm;
  }(_react.Component), _class.propTypes = {
    intl: _reactIntl.intlShape,
    onLoadingStateChanged: _propTypes2.default.func.isRequired,
    onTokenPromiseKey: _propTypes2.default.func.isRequired
  }, _temp;
};

var getTokenPromise = exports.getTokenPromise = function getTokenPromise(key) {
  return tokenPromises[key];
};
var isStripeError = exports.isStripeError = function isStripeError(err) {
  return err && err.isStripeError;
};
var isStripeValidationError = exports.isStripeValidationError = function isStripeValidationError(err) {
  return isStripeError(err) && err.type === 'validation_error';
};